import { Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { EmailGallery, EmailGalleryBoundary } from './-components/dev-resources/email-gallery'
import { EmailGallerySkeleton, EmailsNote, EmailsPending } from './-components/dev-resources/dev-resources-pending'
import { InfoIcon } from './-components/settings/settings-icons'
import { SETTINGS_STACK } from './-components/settings/settings-section'

// The templates are the layout's query (dev-resources.tsx): its tree lists them too.
export const Route = createFileRoute('/_app/dev-resources/emails')({
  component: RouteComponent,
  pendingComponent: EmailsPending,
})

function RouteComponent() {
  return (
    <div className={SETTINGS_STACK}>
      <EmailsNote icon={<InfoIcon className="size-4 shrink-0" />} />
      <EmailGalleryBoundary>
        <Suspense fallback={<EmailGallerySkeleton />}>
          <EmailGallery />
        </Suspense>
      </EmailGalleryBoundary>
    </div>
  )
}
